export const TOP_STORES = [
  {
    categoryId: "3",
    favoriteStores: [9169, 5953, 11398, 11932],
  },
  {
    categoryId: "5",
    favoriteStores: [8004, 7209, 1438, 7810],
  },
  {
    categoryId: "7",
    favoriteStores: [2652, 2798, 2389, 11445],
  },
  {
    categoryId: "8",
    favoriteStores: [1929, 746, 742],
  },
  {
    categoryId: "9",
    favoriteStores: [3688, 3705, 1920, 3746],
  },
  {
    categoryId: "11",
    favoriteStores: [1725, 328, 1726, 1724],
  },
  {
    categoryId: "12",
    favoriteStores: [7937, 8128, 2097, 1719],
  },
  {
    categoryId: "13",
    favoriteStores: [5725, 1307, 2462, 2534],
  },
];

export const MOBILE_MAX_WIDTH_SIZE = 550;
export const TABLET_MAX_WIDTH_SIZE = 1300;
export const SERVER_UNKNOWN_ERROR_MESSAGE_KEY = "SERVER_UNKNOWN_ERROR";

// Environment check for production - determines if site should be indexed by search engines
export const IS_PRODUCTION_ENVIRONMENT =
  process.env.NEXT_PUBLIC_APP_ENV?.toLowerCase() === "production";

export const PREDEFINED_SEARCH_KEYWORDS = {
  clothing: ["robe", "shirt", "plusSize", "pants", "sweater", "woman"],
  petSupplies: ["kibble", "treats", "litter", "dogToy", "catToy", "catTree", "cage"],
  celebrationsAndWeddings: [
    "weddingDress",
    "banquetHall",
    "decoration",
    "flowerBouquet",
    "photographer",
  ],
  motherAndChild: [
    "maternityClothes",
    "newbornEssentials",
    "bottleWarmer",
    "childrenClothes",
    "babyClothes",
    "stroller",
  ],
  healthAndBeauty: [
    "faceSunscreen",
    "faceCleanser",
    "mascara",
    "makeupBrushes",
    "handCream",
    "bodyLotion",
  ],
  gastronomy: [
    "traditionalSweets",
    "savory",
    "sweet",
    "cakes",
    "restaurant",
    "baklava",
    "kaakWarka",
  ],
  leisure: ["guestHouse", "travel", "omra", "travelAgency", "park"],
  homeAndGarden: ["shelf", "table", "washingMachine", "duvet", "parasol", "gardenLounge"],
};
